export default "__VITE_ASSET__0c9e9ec6__"